/**
 * A count with its noun in the right number: `plural(1, 'day')` is "1 day", `plural(3, 'day')` is
 * "3 days". Pass the plural form when adding an "s" is wrong (`plural(2, 'entry', 'entries')`).
 */
export function plural(n: number, singular: string, pluralForm = `${singular}s`): string {
  return `${n} ${n === 1 ? singular : pluralForm}`
}
